import { defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.js';
import isColor from 'is-color';
import { memoizedGet } from './object.esm.js';

/* eslint-disable @typescript-eslint/no-explicit-any */

function bool(cssProp, validComponentProps, lastOneWins) {
  return function (props) {
    var keys = Object.keys(props).filter(function (k) {
      return props[k] && validComponentProps.indexOf(k) >= 0;
    }).map(function (k) {
      return k.replace(/([A-Z])/g, '-$1').toLowerCase();
    });
    if (keys.length) {
      return _defineProperty({}, "".concat(cssProp), lastOneWins ? keys[keys.length - 1] : keys.join(' '));
    }
    return {};
  };
}
var resolveColor = function resolveColor(theme, color) {
  var _color = color ? isColor(color) ? color : memoizedGet(theme, "colors.".concat(color), color) : memoizedGet(theme, 'colors.border');
  return typeof _color === 'string' && _color.startsWith('var') ? _color.slice(_color.indexOf('#')).replace(')', '') : _color;
};

export { bool, resolveColor };
//# sourceMappingURL=styled-props.esm.js.map
